module.exports = __webpack_public_path__ + "img/shopify.0fd377f8.jpg";